<template>
  <div class="pdp-wrapper large-margin-top-xs">
    <main class="content grid-container">
      <RouterView :key="$route.fullPath" />
    </main>

    <Slideout
      v-if="isSlideoutAvailable"
      :id="slideout.id"
      :title="slideout.title"
      :back-config="{ 'backable': slideout.backable, footerText: '' }"
      :position="slideout.position"
      @back-slideout="backSlideout"
      @closeSlideout="fireAnalyticsOnATRClose"
    >
      <component
        :is="slideout.component"
        v-if="slideout.component"
        v-bind="slideout.props"
      />
    </Slideout>
  </div>
</template>

<script setup>
import { Slideout } from '@atomic-ui/slideout';
import { useSlideout } from '@composables/utils/useSlideout';
import useSiteMonGAMTags from '@composables/useSitemonGAMTags';
import onHeader from '@composables/onHeader';
import { useExperimentsProvide } from '@composables/useExperiments';
import { useDeviceTypeProvide } from '@composables/utils/useDeviceType';
import { useATRAnalytics } from '@composables/useATRAnalytics';

useDeviceTypeProvide();
useExperimentsProvide();
useSiteMonGAMTags();
onHeader();
const { slideout, isSlideoutAvailable, backSlideout } = useSlideout();
const { fireAnalyticsOnATRClose } = useATRAnalytics();
</script>

<style lang="scss">
@import "~appSCSS";

.pdp-wrapper {
  display: flex;
  flex-direction: column;
}

.content {
  flex-grow: 1;
}

.header, .content, .footer {
  width: 100%;
}
</style>

<style lang="scss" brand="bcom">
#header.bcom-hidden {
  display: none;
}
</style>

<style lang="scss" brand="mcom">
#header.mcom-mobile-hidden-header {
  display: none;
}
</style>
